import { startOfMonth } from 'date-fns'
import { useMemo, useState } from 'react'

import { BarChart, Card } from '@/components/ui'
import type { CreditBankEntry } from '@/modules/account/types'
import { consumedByDay } from './consumedByDay'
import { MonthPicker } from './MonthPicker'

const dayOfMonth = (date: string) => String(Number(date.slice(8, 10)))

export const UsageByDayChart = ({
  entries,
}: {
  entries: CreditBankEntry[]
}) => {
  const [month, setMonth] = useState(() => startOfMonth(new Date()))
  const data = useMemo(() => consumedByDay(entries, month), [entries, month])
  const hasUsage = data.some((point) => point.value > 0)

  return (
    <Card className="p-4">
      <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
        <h3 className="text-sm font-semibold">Credits used per day</h3>
        <MonthPicker month={month} onChange={setMonth} />
      </div>
      <div className="h-60">
        {hasUsage ? (
          <BarChart
            data={data}
            valueFormat="number"
            xTickFormatter={dayOfMonth}
          />
        ) : (
          <p className="text-muted-foreground flex h-full items-center justify-center text-sm">
            No usage this month.
          </p>
        )}
      </div>
    </Card>
  )
}
